<template>
  <BaseNotification
    v-if="presenterNotification && !isWhiteLabel && !isEu"
    class="aha-public-announcement"
    :class="[
      `critical-${presenterNotification && presenterNotification.criticalLevel}`,
      {
        '--fixed': isFixed,
      },
    ]"
    :showCloseButton="true"
    :showActions="false"
    :loading="isLoadingConfiguration"
    :zIndex="-zIndex"
  >
    <div :inner-html.prop="presenterNotification.content | sanitize(true, false)" />
  </BaseNotification>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Config from '@/config'
import Utils from '@/util'
import BaseNotification from './BaseNotification.vue'

export default {
  components: {
    BaseNotification,
  },
  props: {
    zIndex: {
      type: Number,
      default: 1,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('configuration', [
      'configuration',
      'isLoadingConfiguration',
      'getConfigurationError',
    ]),
    presenterNotification() {
      if (this.configuration.notifications && this.configuration.notifications.length) {
        return this.configuration.notifications.find(
          (noti) => {
            return noti.isEnabled && (noti.where.indexOf('presenter') !== -1 || noti.where.indexOf('all')) !== -1
          },
        )
      }
      return false
    },
    isWhiteLabel() {
      return Utils.checkWhiteLabelDomain()
    },
    isEu() {
      return Config.region === 'eu'
    },
  },
  mounted() {
    this.getConfiguration()
  },
  methods: {
    ...mapActions('configuration', ['getConfiguration']),
  },
}
</script>
<style lang="scss">
// no scoped so it can be used to style dynamic html
.aha-public-announcement.global-notification-bar {
  justify-content: center;
  align-items: center;
  padding-right: 40px;

  // using static position for now
  // &.--fixed {
  //   position: fixed;
  //   width: calc(100% - 14rem); // sidebar = 14rem
  //   @media (max-width: 1024px) {
  //     width: 100%;
  //   }
  // }

  &.critical-1 {
  }
  &.critical-2 {
    background-color: #FFA826;
    box-shadow: 0px 4px 4px rgba(132, 112, 0, 0.438);
  }
  &.critical-3 {
    background-color: #DA323C;
    box-shadow: 0px 4px 4px rgba(132, 0, 0, 0.438);
  }

  .aha-public-announcement-content {
    margin: 0;
    font-size: 14px !important;
  }
  .aha-public-announcement-url {
    color: #fff;
    text-decoration: underline !important;
    font-weight: bold;
    &:hover {
      color: #EBEBEB !important;
    }
  }
}
</style>
